export default function IconConnect({
    VIEW_SIZE = 128,
    borderColor = '#287ef6',
    fill = 'none',
    strokeWidth = 0
}) {
    const s = VIEW_SIZE
    const w = strokeWidth / 2

    const d = `
        M ${w},${w}
        L ${s - w},${w}
        L ${s - w},${s * 0.5}
        L ${s * 0.5},${s - w}
        L ${w},${s * 0.5}
        Z
    `

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox={`0 0 ${s} ${s}`}
        >
            <path
                d={d}
                fill={fill}
                strokeWidth={strokeWidth}
                stroke={borderColor}
            />
        </svg>
    )
}
